import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AddIcon from "@atlaskit/icon/core/add";
import { Popover } from "antd";
import Tooltip from "@atlaskit/tooltip";
import { useParams } from "react-router-dom";
import { selectCurrentURL } from "../../../../redux/actions/integrationActions";
import CreateActionPage from "./CreateActionPage";
import ActionTree from "./ActionTree";
import ActionSelectList from "../../../../common/components/ActionSelectList";
import { Inline } from "@atlaskit/primitives";
import { clearScriptResult } from "../../../../redux/actions/testFlowActions";
import OrderActionButton from "./OrderActionButton";
import DuplicateActionMenuItem from "../action/menu/DuplicateActionMenuItem";
import DeleteActionMenuItem from "../action/menu/DeleteActionMenuItem";
const ActionSidebarSection = ({ navigationCallback }) => {
  const flow = useSelector((state) => state.integration.flow);
  const [showCreateActionPopup, setShowCreateActionPopup] = useState(false);
  const dispatch = useDispatch();
  const { sectionId = "" } = useParams();

  const selectedAction = flow?.actions?.find((a) => a.id === sectionId);

  const handleClickChange = (visible) => {
    setShowCreateActionPopup(visible);
  };

  const handleNavigateTo = (id) => {
    navigationCallback("/integration/" + flow.id + "/action/" + id);
    // history.push("/integration/" + flow.id + "/action/" + id);
    const action = flow.actions.find((a) => a.id === id);
    dispatch(selectCurrentURL(action.url));
    dispatch(clearScriptResult());
  };

  const tooltipText =
    "Actions interact with APIs. Use templates or webactions for simple requests. Combine multiple actions for complex tasks. They run in order, and child actions can use data from parent actions";

  return (
    <div className="ihub-sidebar-action-widget">
      <Inline alignBlock="center" spread="space-between">
        <span className="atlassian-theme">
          <b>Actions</b>
        </span>
        <Inline alignBlock="center" space="space.100">
          <OrderActionButton />
          <Popover
            content={<CreateActionPage close={setShowCreateActionPopup} />}
            title="Add new action"
            trigger="click"
            open={showCreateActionPopup}
            onOpenChange={handleClickChange}
          >
            <div className="ihub-sidebar-action-widget-add-action">
              <AddIcon label="" />
              <Tooltip position="top" content={tooltipText}>
                <span className="ihub-sidebar-action-widget-add-action-text">Add</span>
              </Tooltip>
            </div>
          </Popover>
        </Inline>
      </Inline>

      <div className="ihub-sidebar-action-widget-select-row">
        <div className="ihub-sidebar-action-widget-picker">
          <ActionSelectList onClickCallback={handleNavigateTo} />
        </div>
      </div>
      {selectedAction ? (
        <div className="ihub-sidebar-action-widget-actions-row">
          <Inline alignBlock="center" space="space.050">
            <DuplicateActionMenuItem action={selectedAction} iconOnly />
            <DeleteActionMenuItem action={selectedAction} iconOnly />
          </Inline>
        </div>
      ) : null}

      <div className="ihub-sidebar-action-widget-action-list">
        <ActionTree callback={handleNavigateTo} activeClassName="ihub-action-list-style-active" />
      </div>
    </div>
  );
};
export default ActionSidebarSection;
